import { HttpResource } from '@fos/core';

import { accessTokenStore } from '../store/AccessTokenStore';
import { environmentStore } from '../store/EnvironmentStore';

export type LoadStatuses = 'inital' | 'loading' | 'loaded' | 'error';

export class HttpClient {
  static SmartLogCloud: HttpResource;
  static FssCloud: HttpResource;

  static init(): void {
    HttpClient.SmartLogCloud = new HttpResource(
      environmentStore.environmentWithVesselId.smartlogCloudApi,
      {},
      { getToken: () => accessTokenStore.tokens.value }
    );
  }
}
